import { StatsGtmDataLayerDefaultInterface } from 'common/module/stats/gtm/data-layer/default.interface';

export const UserSignInStatsGtmLogoutUser = (eventLabel: string): StatsGtmDataLayerDefaultInterface => ({
  event: 'Userbox',
  eventAction: 'Logged out:User',
  eventLabel,
});
